import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'

// app工会长薪资转金币页面配置信息 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41450232
export const wage_to_coins_cfg = createAsyncThunk(
  'withdraw_union_leader_wage_to_coins_cfg',
  async (arg, store: any) => {
    const resp = await http.post<
      HiyaRes<
        Pick<
          InitialStateType,
          | 'err_msg'
          | 'is_pop'
          | 'pop_text'
          | 'balance'
          | 'divide_money'
          | 'wage_to_coins_switch'
          | 'ra_ratio_list'
          | 'ratio_list'
          | 'count_down'
        >
      >
    >(
      '/live/union/wage_to_coins_cfg',
      {
        ...store.getState().env.deviceinfo,
      },
      {
        xcErrorToast: true,
      }
    )
    return resp.data.data
  }
)

// 公会长薪资转金币 https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41449707
export const wage_to_coins = createAsyncThunk(
  'withdraw_union_leader_wage_to_coins',
  async (arg: {money: number; ensure_exchange: 0 | 1}, store: any) => {
    const resp = await http.post<
      HiyaRes<Pick<InitialStateType, 'err_msg' | 'money' | 'coins'>>
    >('/live/union/wage_to_coins', {
      ...store.getState().env.deviceinfo,
      ...arg,
    })
    return resp.data.data
  }
)

interface InitialStateType {
  // 是否调往薪资确认页面
  is_pop?: boolean
  pop_text?: string
  count_down?: number
  // 薪资确认页面地址
  pop_url?: string
  // 余额
  balance?: number
  // 币商金币 最小的转换数
  divide_money?: number
  wage_to_coins_switch?: boolean
  // 币商配置列表
  ra_ratio_list?: Array<{range: string; ratio: string}>
  // 普通配置列表
  ratio_list?: Array<{range: string; ratio: string}>

  err_msg?: string
  money?: number
  coins?: number
}

const initialState: InitialStateType = {}

export const UnionLeaderWithdrawSalarySlice = createSlice({
  name: 'UnionLeaderWithdrawSalary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(wage_to_coins_cfg.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default UnionLeaderWithdrawSalarySlice.reducer
